import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ScheduledMessages from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/scheduled-messages'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'scheduled_messages_settings_index',
          component: ScheduledMessages,
          meta: {
            permissions: ['administrator', 'follow_up_manage'],
          },
        },
      ],
    },
  ],
};
